import { Select } from '@/components/ui/select';
import { useTableContext } from '@/contexts/table-context';

import { useOpeningsFilters } from './use-openings-filters';

export function Filters() {
  const { setFilters } = useTableContext();
  const filters = useOpeningsFilters();

  const handleApply = (
    selectedValues: (string | boolean | undefined)[],
    id: string,
  ) => {
    const isMulti = filters.find(f => f.filterKey === id)?.isMultiSelect;

    setFilters(prev => ({
      ...prev,
      [id]: isMulti ? selectedValues : selectedValues[0],
    }));
  };

  return (
    <div className="flex flex-row gap-2">
      {filters.map(filter => (
        <Select
          key={filter.label}
          id={filter.filterKey}
          options={filter.options ?? []}
          selectedValues={filter.selectedValues}
          prefixText={`${filter.label}:`}
          query={filter.query}
          setQuery={filter.setQuery}
          isLoading={filter.isFetching}
          isMultiSelect={filter.isMultiSelect}
          onApply={handleApply}
          className="rounded-lg"
        />
      ))}
    </div>
  );
}
